import { BodyText, Stack, Title, Caption } from '@kvdbil/components';
import React, { useCallback } from 'react';
import BankIdAuthButton from '~/App/shared/components/Auth/components/BankIdAuthButton';
import { VerifyBankID } from '~/App/shared/components/Auth/VerifyBankID';
import { useTranslation } from '~/Locale';
import NoBankIdInfo from './NoBankIdInfo';

interface Props {
  isPending: boolean;
  setIsPending: (isPending: boolean) => void;
}

const BiddingPrivCustomerBankIdVerification = ({
  isPending,
  setIsPending
}: Props) => {
  const { t } = useTranslation();

  const onSuccessBankIdVerificationCallback = useCallback(() => {
    setTimeout(() => {
      setIsPending(false);
    }, 2000);
  }, [setIsPending]);

  if (isPending) {
    return (
      <VerifyBankID
        onClose={() => setIsPending(false)}
        onSuccess={onSuccessBankIdVerificationCallback}
      />
    );
  }

  return (
    <Stack spacing={2} data-testid="customer-bankid-verification">
      <Stack>
        <Title as="h3" style={{ textAlign: 'center' }}>
          {t('Verify your information')}
        </Title>
        <BodyText>{t('You must verify your information to proceed.')}</BodyText>
      </Stack>
      <Stack>
        <div>
          <BankIdAuthButton fullWidth onClick={() => setIsPending(true)}>
            {t('Verify with BankID')}
          </BankIdAuthButton>
          <Caption>
            {t(
              'We need to verify your account with BankID to ensure your identity.'
            )}
          </Caption>
        </div>
        <NoBankIdInfo />
      </Stack>
    </Stack>
  );
};

export default BiddingPrivCustomerBankIdVerification;
